<template>
  <div class="error-container">
    <div class="error-content">
      <div class="error-title">
        <v-icon large color="error" class="mr-3">mdi-alert-circle</v-icon>
        <h2>Calculation Error</h2>
      </div>
      <div class="error-text">
        <p>There was a problem processing your calculation request.</p>
        <p>You can try again or check your input parameters.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KDiagramErrorView",
  data() {
    return {
      isRetrying: false,
    };
  },
};
</script>

<style scoped>
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background: var(--gradient-primary) !important;
}

.error-content {
  text-align: center;
  max-width: 500px;
  padding: 30px;
  background-color: var(--color-bg);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}

.error-title {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-error);
  margin-bottom: 20px;
}

.error-text {
  font-size: 16px;
  margin-bottom: 25px;
  color: var(--color-text);
}

.error-actions {
  margin-top: 10px;
}
</style>
